"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ratingModule = _interopRequireDefault(require("./rating.module.scss"));
var _StarsRatingSmallSelected = _interopRequireDefault(require("../../elements/icons/StarsRatingSmallSelected"));
var _StarsRatingSmallDeSelected = _interopRequireDefault(require("../../elements/icons/StarsRatingSmallDeSelected"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Suffix = function Suffix(_ref) {
  var suffixType = _ref.suffixType,
    rating = _ref.rating;
  var averageRating = rating.averageRating,
    reviews = rating.reviews;
  switch (suffixType) {
    case 'none':
      return null;
    case 'ratingAndCount':
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: _ratingModule["default"].fontSmall,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _ratingModule["default"].visuallyHidden,
          children: "The average rating is"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _ratingModule["default"].rating,
          children: averageRating
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _ratingModule["default"].visuallyHidden,
          children: "from"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _ratingModule["default"].ratingAndCount,
          children: "/"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _ratingModule["default"].ratingAndCount,
          children: reviews
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _ratingModule["default"].visuallyHidden,
          children: reviews !== 1 ? 'reviews' : 'review'
        })]
      });
    case 'ratingAndMax':
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _ratingModule["default"].visuallyHidden,
          children: "The average rating is"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _ratingModule["default"].rating,
          children: averageRating
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _ratingModule["default"].visuallyHidden,
          children: "out of"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          "aria-hidden": "true",
          children: "/"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _ratingModule["default"].ratingAndCount,
          children: "5"
        })]
      });
    case 'reviews':
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _ratingModule["default"].visuallyHidden,
          children: reviews !== 1 ? 'There are ' : 'There is '
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          "aria-hidden": "true",
          children: "("
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          className: _ratingModule["default"].reviews,
          children: [reviews, " ", reviews !== 1 ? 'reviews' : 'review']
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          "aria-hidden": "true",
          children: ")"
        })]
      });
    default:
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _ratingModule["default"].visuallyHidden,
          children: reviews !== 1 ? 'There are ' : 'There is '
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _ratingModule["default"].reviews,
          children: reviews
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _ratingModule["default"].visuallyHidden,
          children: reviews !== 1 ? ' reviews' : ' review'
        })]
      });
  }
};
var Rating = function Rating(_ref2) {
  var _ref2$rating = _ref2.rating,
    rating = _ref2$rating === void 0 ? {} : _ref2$rating,
    _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? '' : _ref2$className,
    suffixType = _ref2.suffixType,
    size = _ref2.size,
    _ref2$ownRating = _ref2.ownRating,
    ownRating = _ref2$ownRating === void 0 ? false : _ref2$ownRating;
  var averageRating = rating.averageRating,
    reviews = rating.reviews;
  if (!Object.keys(rating).length || !reviews) {
    return '';
  }
  var ratingStarsWidth = averageRating * 20;
  var averageRatingParsed = parseFloat(averageRating).toFixed(2);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: (0, _classnames["default"])(_ratingModule["default"].ratings, _ratingModule["default"][size], _ratingModule["default"]['size-joyfully-bold']),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "".concat(_ratingModule["default"].starRatings, " ").concat(className),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: _ratingModule["default"].starDefault,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_StarsRatingSmallDeSelected["default"], {
            className: (0, _classnames["default"])(_ratingModule["default"].starOutline, _ratingModule["default"]['joyfully-bold']),
            height: 14
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: _ratingModule["default"].starRated,
          style: {
            width: "".concat(ratingStarsWidth, "%")
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_StarsRatingSmallSelected["default"], {
            className: (0, _classnames["default"])(_ratingModule["default"].starFilled, _ratingModule["default"]['joyfully-bold']),
            height: 14
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
            className: _ratingModule["default"].visuallyHidden,
            "data-test": "rating",
            "data-testid": "rating-accessibility",
            children: ["Product review details,", ' ', ownRating ? "you rated this product ".concat(averageRatingParsed, " out of 5 stars.") : "this product has received, on average,".concat(' ', "\n              ", averageRatingParsed, " out of 5 star rating.")]
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: (0, _classnames["default"])(_ratingModule["default"].suffix, _ratingModule["default"]['suffix-joyfully-bold']),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Suffix, {
          suffixType: suffixType,
          rating: rating
        })
      })]
    })
  });
};
Rating.defaultProps = {
  rating: {},
  className: '',
  suffixType: 'count',
  size: 'small'
};
Rating.propTypes = {
  className: _propTypes["default"].string,
  rating: _propTypes["default"].shape({
    averageRating: _propTypes["default"].number,
    reviews: _propTypes["default"].number
  }),
  size: _propTypes["default"].oneOf(['small', 'large']),
  suffixType: _propTypes["default"].oneOf(['count', 'none', 'ratingAndCount', 'reviews', 'ratingAndMax']),
  ownRating: _propTypes["default"].bool
};
Suffix.defaultProps = {
  rating: {},
  suffixType: 'count'
};
Suffix.propTypes = {
  rating: _propTypes["default"].shape({
    averageRating: _propTypes["default"].number,
    reviews: _propTypes["default"].number
  }),
  suffixType: _propTypes["default"].oneOf(['count', 'none', 'ratingAndCount', 'reviews', 'ratingAndMax'])
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Rating);